import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { ChangeVideoBackgroundButton } from './styled';
import { ImageIcon } from '@/shared/assets/icons';
import { popupStore } from '@/shared/model/popup';
import { BackgroundImagePicker } from '@/entities/background-image-picker/ui';
export const ChangeVideoBackground = (props) => {
    const buttonRef = useRef(null);
    const handleOpenPopup = useCallback(() => {
        if (!buttonRef?.current) {
            return;
        }
        popupStore.anchorOrigin = {
            horizontal: 'left',
            vertical: 'bottom',
        };
        popupStore.offsetFromAnchor = '4px 0';
        popupStore.anchorEl = buttonRef.current;
        popupStore.content = _jsx(BackgroundImagePicker, {});
        popupStore.userC = 0;
    }, []);
    return (_jsx(ChangeVideoBackgroundButton, { ref: buttonRef, onClick: handleOpenPopup, ...props, children: _jsx(ImageIcon, {}) }));
};
